import React, {useEffect, useState} from 'react';
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "context/OperatorContext";
import {useNotifications} from "context/NotificationContext";
import {Conversation} from "../../../types/Conversation";

type DeleteConversationProps = {
    conversation: Conversation | null
    show: boolean
    onDelete?: (conversation: Conversation) => any
    onDeleteFail?: (conversation: Conversation, error: unknown) => any
    onCancel?: () => any
}

function DeleteConversation(props: DeleteConversationProps) {
    const {conversation, show, onDelete, onDeleteFail, onCancel} = props

    const {termFor} = useOperator()
    const {notify} = useNotifications()

    const [name, setName] = useState<string>(conversation?.title || `this ${termFor('conversation')}`);
    const {mutateAsync: deleteConversation} = useMutation(ngage.conversations.destroy)

    useEffect(() => {
        if(conversation) setName(conversation.title)
    }, [conversation]);

    async function handleDelete() {
        if (conversation) {
            try {
                await deleteConversation(conversation.id)
                await invalidate('conversations.all')

                notify("success", `${termFor('Conversation')} Deleted`, `${conversation.title} has been permanently removed`)
                if (onDelete) onDelete(conversation)
            } catch (error) {
                notify("error", `${termFor('Conversation')} Not Deleted`, `${conversation.title} could not be removed`)
                if (onDeleteFail) onDeleteFail(conversation, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Conversation')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDelete}
            onCancel={handleCancel}
        />
    );
}

export default DeleteConversation;